module.exports = __webpack_public_path__ + "ff6b84e9200f36491ec99ade17c6552d.svg";